import { createPopper } from "@popperjs/core";
import { holidays } from "./modules/locationConfig";
declare global {
  interface Window {
    jQuery: any;
    // gtag: any;
    fbq: any;
    ttq: any;
  }
}

// Format the date for the new booking flow
export const formatDate = (date: Date, format: string = "MM DD, YYYY") => {
  let formattedDate = new Date(date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "utc",
  });

  if (format == "M DD, YYYY") {
    formattedDate = new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: "utc",
    });
  }

  if (format == "MM DD, YYYY") {
    formattedDate = new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "utc",
    });
  }

  return formattedDate;
};

// Get day of week
export const GetDayOfWeek = (date: Date) => {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return days[date.getDay()];
};

// Get the previous timeslots
export const GetPreviousTimeslot = (
  timeslots: string[],
  blockedTimeslots: string[],
  location: string
) => {
  if (location.toLowerCase() === "nashville") {
    // Validations
    if (blockedTimeslots.length > 0) {
      let newBlockedTimeslots: string[] = [];
      blockedTimeslots.forEach((ts) => {
        const idx = timeslots.findIndex((el) => el === ts);
        if (idx !== -1 && idx !== 0) {
          newBlockedTimeslots.push(timeslots[idx - 1]);
        }
      });
      if (newBlockedTimeslots.length > 0) {
        return newBlockedTimeslots;
      }
      return null;
    }
  }
  return null;
};

// Get the money sign depending of the country
export const GetMoneySign = (country: string): string => {
  if (country.toLowerCase() === "uk") return "£";
  else return "$";
};

// Get the type of time
export const IsPrimeTime = (time: string, location: string) => {
  if (location.toLowerCase() === "windsor") {
    return false;
  }

  let standardTime = ["08:00", "10:00", "12:00", "14:00"];
  let primeTime = ["16:00", "18:00", "20:00", "22:00"];

  if (standardTime.includes(time)) return false;
  if (primeTime.includes(time)) return true;

  return false;
};

// Get min for large group by location
export const GetMinLargeGroupSize = (location: string): number => {
  const largeGroupSize = {
    default: 30,
    frisco: 16,
    croydon: 24,
    "wembley, london": 24,
    windsor: 24,
  };

  if (largeGroupSize.hasOwnProperty(location.toLowerCase())) {
    let val = Object.keys(largeGroupSize).find(
      (key) => key === location.toLowerCase()
    );
    return val as unknown as number;
  }

  return largeGroupSize["default"] as number;
};

export const GetMinGroupsize = (group: string) => {
  if (!group) return 4;
  if (group.match(/^(?<group>[0-9]{1,2})-([0-9]{1,2})/i)) {
    return group.substring(0, group.indexOf("-")) as unknown as number;
  } else if (group.match(/^(?<group>[0-9]{1,3})-([0-9]{1,3})/i)) {
    return group.substring(0, group.indexOf("-")) as unknown as number;
  } else if (group.match(/^(?<group>[0-9]{1,})+/i)) {
    return group.substring(0, group.indexOf("+")) as unknown as number;
  } else {
    return 1;
  }
};

/**
 * Get Lanes by Group Size
 */
export const GetLanesByGroupSize = (group: string, location: string) => {
  let currentGroup: number = 1;

  let groupTest = group.match(/^(?<groupStart>[0-9]{1})-(?<groupMax>[0-9]{1,2})/i);
  if (group.match(/^(?<group>[0-9]{1,2})-([0-9]{1,2})/i)) {
    let groupMatch = group.match(/^([0-9]{1,2})-([0-9]{1,2})/i);
    currentGroup = group.substring(0, group.indexOf("-")) as unknown as number;
    if (location.toLowerCase() === 'winnipeg') {
      if (groupMatch != null) {
        // currentGroup = parseInt(groupMatch!['groups']);
        currentGroup = parseInt(groupMatch[2]);
      }
    }
  } else if (group.match(/^(?<group>[0-9]{1,})\+/i)) {
    currentGroup = group.substring(0, group.indexOf("+")) as unknown as number;
  } else if (group.match(/^(?<group>[0-9]{1,3})-([0-9]{1,3})/i)) {
    currentGroup = group.substring(0, group.indexOf("-")) as unknown as number;
  } else if (group.match(/^(?<group>[0-9]{1,})/i)) {
    currentGroup = group as unknown as number;
  } else {
    return 1;
  }

  let lanesGroup: { [option: string]: {} } = {
    default: {
      "13": 2,
      "25": 3,
      "31": 3,
      "36": 3, // holiday party package
      "37": 4,
      "49": 5,
      "61": 6,
      "73": 7,
      "85": 8,
      "97": 9,
      "109": 10,
      "121": 11,
      "133": 12,
      "145": 13,
      "157": 14,
      "169": 15,
      "181": 16,
    },
    windsor: {
      "13": 2,
      "25": 3,
      "37": 4,
      "61": 4,
    },
    winnipeg: {
      "9": 2,
    },
    nashville: {
      "15": 2,
      "25": 3,
      "31": 3,
      "37": 4,
      "49": 5,
      "61": 6,
    },
  };

  let locationGroups: any;
  Object.keys(lanesGroup).forEach((laneGroup) => {
    if (laneGroup.toLowerCase() === location.toLowerCase()) {
      locationGroups = lanesGroup[laneGroup];
    }
  });

  if (!locationGroups) {
    locationGroups = lanesGroup["default"];
  }

  let prevGroup: number = 0;
  let found: boolean = false;
  let lanes: number = 1;

  Object.keys(locationGroups).forEach((g) => {
    if (!found) {
      if (
        currentGroup >= prevGroup &&
        currentGroup < parseInt(g) &&
        typeof locationGroups[prevGroup] !== "undefined"
      ) {
        lanes = locationGroups[prevGroup];
        found = true;
      }
      prevGroup = parseInt(g);
    }
  });

  if (currentGroup >= prevGroup) {
    lanes = locationGroups[prevGroup];
  }

  return lanes;
};

/**
 * Get Lanes by Group Size Teambuilding
 */
export const GetLanesByGroupSizeTeambuilding = (
  group: string,
  location: string
) => {
  let currentGroup: number = 1;

  if (group.match(/^(?<group>[0-9]{1,2})-([0-9]{1,2})/i)) {
    // currentGroup = group.substring(1, group.indexOf('-')) as unknown as number;
    currentGroup = group.split("-")[1] as unknown as number;
  } else if (group.match(/^(?<group>[0-9]{1,})+/i)) {
    currentGroup = group.substring(0, group.indexOf("+")) as unknown as number;
  } else {
    return 1;
  }

  let lanesGroup: { [option: string]: {} } = {
    default: {
      "13": 2,
      "25": 3,
      "31": 3,
      "37": 4,
      "49": 5,
      "61": 6,
      "73": 7,
      "85": 8,
      "97": 9,
      "109": 10,
      "121": 11,
      "133": 12,
      "145": 13,
      "157": 14,
      "169": 15,
      "181": 16,
    },
    windsor: {
      "21": 2,
      "31": 3,
      "41": 3,
    },
    nashville: {
      "15": 2,
      "25": 3,
      "31": 3,
      "37": 4,
      "49": 5,
      "61": 6,
    },
  };

  let locationGroups: any;
  Object.keys(lanesGroup).forEach((laneGroup) => {
    if (laneGroup.toLowerCase() === location.toLowerCase()) {
      locationGroups = lanesGroup[laneGroup];
    }
  });

  if (!locationGroups) {
    locationGroups = lanesGroup["default"];
  }

  let prevGroup: number = 0;
  let found: boolean = false;
  let lanes: number = 1;

  Object.keys(locationGroups).forEach((g) => {
    if (!found) {
      if (
        currentGroup >= prevGroup &&
        currentGroup < parseInt(g) &&
        typeof locationGroups[prevGroup] !== "undefined"
      ) {
        lanes = locationGroups[prevGroup];
        found = true;
      }
      prevGroup = parseInt(g);
    }
  });

  if (currentGroup >= prevGroup) {
    lanes = locationGroups[prevGroup];
  }
  return lanes;
};

/**
 * Conver Timeslots from 24 to 12 hours format
 * @param timeslot
 * @returns {string}
 */
export const From24to12 = (timeslot: string | null = null) => {
  if (timeslot === null) return;

  const hourEnd = timeslot.indexOf(":");
  const H = +timeslot.substr(0, hourEnd);
  const h = H % 12 || 12;
  const ampm = H < 12 || H === 24 ? "AM" : "PM";
  return `${h}${timeslot.substr(hourEnd, 3)} ${ampm}`;
};

// Check if date is a holiday depending of the type of holiday
export const isHoliday = (
  bookDate: Date,
  location: string,
  country: string
) => {
  const formattedDate = `${bookDate.getFullYear()}-${bookDate.getMonth() + 1
    }-${bookDate.getDate()}`;
  let countryName =
    country.toLowerCase() === "ca" ? "canada" : country.toLowerCase();

  let canadaSpecialHolidays1 = [
    "missisauga",
    "burlington",
    "vaughan",
    "ottawa",
    "waterloo",
    "kitchener",
  ];
  let canadaSpecialHolidays2 = ["winnipeg"];
  let canadaSpecialHolidays3 = ["surrey"];

  if (countryName === "canada") {
    // Check if
    if (holidays[countryName][bookDate.getFullYear()].includes(formattedDate)) {
      return true;
    } else {
      if (canadaSpecialHolidays1.includes(location.toLowerCase())) {
        return holidays["canada_1"][bookDate.getFullYear()].includes(
          formattedDate
        );
      } else if (canadaSpecialHolidays2.includes(location.toLowerCase())) {
        return holidays["canada_2"][bookDate.getFullYear()].includes(
          formattedDate
        );
      } else if (canadaSpecialHolidays3.includes(location.toLowerCase())) {
        return holidays["canada_3"][bookDate.getFullYear()].includes(
          formattedDate
        );
      } else {
        return false;
      }
    }
  } else {
    return holidays[countryName][bookDate.getFullYear()].includes(
      formattedDate
    );
  }
};

// Holidays Groupsizes
export const holidaysGroupSizes = (groupSizes: string[], country: string) => {
  if (country.toLowerCase() === "canada") {
    return (
      groupSizes
        // .filter((g) => {
        //   if (g === "8-12") return false;
        //   return true;
        // })
        .map((g) => {
          // if (g === "4-7") return "6-12";
          if (g === "1-3") return "1-5";
          if (g === "4-8") return "6-8";
          return g;
        })
    );
  }

  if (country.toLowerCase() === "us") {
    return (
      groupSizes
        // .filter((g) => {
        //   if (g === "8-12") return false;
        //   return true;
        // })
        .map((g) => {
          if (g === "1-3") return "1-5";
          if (g === "4-8") return "6-8";
          return g;
        })
    );
  }
  return groupSizes;
};

/**
 * Validations
 * @param email
 */
export const validateEmail = (email: string) => {
  const regex =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return regex.test(email);
};

export const phoneFormat = (country: string, phone: string) => {
  let phoneRegex = /(\d{1,3})(\d{1,3})?(\d{1,4})?/g;
  let phoneMaximum = 10;

  if (country.toLowerCase() === "uk") {
    phoneRegex = /(\d{1,4})(\d{1,3})?(\d{1,4})?/g;
    phoneMaximum = 11;
  }

  return (
    phone
      .replace(/\D/g, "")
      .substring(0, phoneMaximum)
      // @ts-ignore
      .replace(phoneRegex, (txt: string, f: any, s: any, t: any) => {
        if (t) {
          return `(${f}) ${s}-${t}`;
        } else if (s) {
          return `(${f}) ${s}`;
        } else if (f) {
          return f;
          // return `(${f})`;
        }
      })
  );
};

// get Group Size minimum from string
export const groupSizeMinimum = (groupSize: string) => {
  const delimiter = groupSize.includes("-") ? "-" : "+";
  return parseInt(groupSize.substr(0, groupSize.indexOf(`${delimiter}`)));
};

export const isFriday = (date: Date) => {
  if (date.getDay() === 5) return true;
  return false;
};

export const isSaturday = (date: Date) => {
  if (date.getDay() === 6) return true;
  return false;
};

export const isMonday = (date: Date) => {
  if (date.getDay() === 1) return true;
  return false;
};

export const isTuesday = (date: Date) => {
  if (date.getDay() === 2) return true;
  return false;
};

// Check if book is last hour
export const isLastMinute = (bookDate: Date) => {
  const current = new Date();
  const bDate = new Date(bookDate);

  const msBetweenDates = Math.abs(bDate.getTime() - current.getTime());
  const hourBetweenDates = msBetweenDates / (60 * 60 * 1000);

  if (hourBetweenDates < 48) {
    return true;
  }

  return false;
};

// Check if can use Webp files
export const canUseWebP = () => {
  var elem = document.createElement("canvas");
  if (!!(elem.getContext && elem.getContext("2d"))) {
    // was able or not to get WebP representation
    return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
  }
  // very old browser like IE 8, canvas not supported
  return false;
};

export const tooltip = (
  baseEl: any,
  tooltipEl: any,
  conf: any,
  events: any
) => {
  const offsetValue = typeof conf.offset !== "undefined" ? conf.offset : [0, 0];

  let popperInstance = createPopper(baseEl, tooltipEl, {
    placement: conf.placement,
    modifiers: [
      {
        name: "offset",
        options: {
          offset: offsetValue,
        },
      },
    ],
  });

  events.show.forEach((e: any) => {
    baseEl.addEventListener(e, (e: any) => {
      tooltipEl.setAttribute("data-show", "");

      // Enable the event listeners
      popperInstance.setOptions({
        modifiers: [
          { name: "eventListeners", enabled: true },
          { offset: offsetValue },
        ],
      });

      popperInstance.update();
    });
  });

  events.hide.forEach((e: any) => {
    baseEl.addEventListener(e, (e: any) => {
      tooltipEl.removeAttribute("data-show");
      // Disable the event listeners
      popperInstance.setOptions({
        modifiers: [
          { name: "eventListeners", enabled: false },
          { offset: offsetValue },
        ],
      });
    });
  });

  return {
    show: () => {
      tooltipEl.setAttribute("data-show", "");
      popperInstance.setOptions({
        modifiers: [
          { name: "eventListeners", enabled: true },
          { offset: offsetValue },
        ],
      });
      popperInstance.update();
    },
    hide: () => {
      tooltipEl.removeAttribute("data-show");
      popperInstance.setOptions({
        modifiers: [
          { name: "eventListeners", enabled: false },
          { offset: offsetValue },
        ],
      });
    },
  };
};

/**
 * Insert errors inside element
 */
export const error = (
  parentEl: HTMLElement,
  text: string,
  hideClass: string | null = null,
  duration = 2000
) => {
  if (parentEl === null) return;

  const errorChild = document.createElement("p");
  errorChild.textContent = text;
  parentEl.appendChild(errorChild);

  if (hideClass != null) {
    parentEl.classList.remove("hidden");

    setTimeout(() => {
      parentEl.classList.add("hidden");
    }, duration);
  }
};

export const customerBookValidation = (
  params = {
    fullName: "",
    // firstName: "",
    // lastName: "",
    email: "",
    phone: "",
    aproxGroupSize: "",
    bookingType: "",
  }
) => {
  let valid = true;

  // Full Name
  if (params.fullName === "" || params.fullName.length < 2) {
    valid = false;
  }

  // First Name
  // if (params.firstName === "" || params.firstName.length < 2) {
  //   valid = false;
  // }

  // Last Name
  // if (params.lastName === "" || params.lastName.length < 2) {
  //   valid = false;
  // }

  if (params.email === "" || !validateEmail(params.email)) {
    valid = false;
  }

  if (params.phone === "") {
    valid = false;
  }

  // if ( params.bookingType != 'team-building' ) {
  //     if (params.aproxGroupSize === '' || params.aproxGroupSize.length === 0) {
  //         valid = false;
  //     }
  // }

  return valid;
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

// Jump to section
export const jumpTo = (anchor: any = null, remove = 0) => {
  if (anchor !== null) {
    if (anchor.includes("#")) {
      if (document.querySelector(`${anchor}`) !== null) {
        const top =
          (document.querySelector(`${anchor}`) as HTMLElement)!.offsetTop -
          remove; // Getting Y of target element
        window.scrollTo(0, top);
      }
    } else {
      if (document.getElementById(`${anchor}`)) {
        const top = document.getElementById(`${anchor}`)!.offsetTop - remove; // Getting Y of target element
        window.scrollTo(0, top);
      }
    }
  }
};

// Google Analytics Events
export const gaEvent = (title = null, subtitle = null, value = null) => {
  if (title !== null && subtitle !== null && value !== null) {
    // ga('send', 'event', title, subtitle, value);
    // window.gtag("send", "event", title, subtitle, value);
    let infoEvent = {
      [subtitle]: value,
    };
    if (typeof window.gtag === 'function') {
      window.gtag("event", title, infoEvent);
    } else {
      console.warn('Google Analytics gtag function is not available. Event not sent:', { title, subtitle, value });
    }
  }
};

/**
 * @TODO: Check if this function is being used correctly and check if params has the correct format
 */
export const gaEventParams = (type: string, params: object = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag("event", type, params);
  } else {
    console.warn('Google Analytics gtag function is not available. Event not sent:', { type, params });
  }
};

export const sendGAEvent = (
  action: string,
  category: string,
  label: string
) => {
  if (typeof window.gtag === 'function') {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
    });
  } else {
    console.warn('Google Analytics gtag function is not available on window.');
  }
};

export const updateUrl = (anchor: any) => {
  let hash = location.hash.replace("#", "");
  let shortPath =
    typeof document.location.pathname != "undefined"
      ? document.location.pathname
      : "/";

  if (anchor != "") {
    location.hash = anchor;
    if (typeof window.gtag === 'function') {
      window.gtag("send", "event", "booking", "step", anchor);
      window.gtag("send", "pageview", shortPath + anchor);
    } else {
      console.warn('Google Analytics gtag function is not available.');
    }
  }
};

// Facebook Events
// Options: track | trackCustom
export const fbEvent = (type = "track", name = null, params = null) => {
  if (name !== null) {
    if (params !== null) {
      window.fbq(type, name, params);
    } else {
      window.fbq(type, name);
    }
  }
};

export const onDocumentLoad = (cb: () => void) => {
  if (typeof document === "undefined") {
    throw new Error("this function runs only in the browser");
  }

  let state = document.readyState;
  if (state === "complete" || state === "interactive") {
    return setTimeout(cb, 0);
  }

  document.addEventListener("DOMContentLoaded", () => {
    cb();
  });
};

// TikTok Pixel Events
// Options: track
export const ttqEvent = (name = "track", params = null) => {
  if (name !== null) {
    if (params !== null) {
      window.ttq.track(name, params);
    } else {
      window.ttq.track(name);
    }
  }
};

// function to check if received date is under 48 hours from current date
export const isUnder48Hours = (date: Date) => {
  if (date === null) return false;
  const currentDate = new Date();
  const diff = date?.getTime() - currentDate.getTime();
  const diffInHours = diff / (1000 * 60 * 60);
  return diffInHours < 48;
};

const searchLazyScripts = () => {
  document
    .querySelectorAll("script[data-type='lazy']")
    .forEach((el: Element) => {
      if (el instanceof HTMLElement) {
        el.setAttribute("src", el.getAttribute("data-src") as string);
        el.removeAttribute("data-src");
        el.removeAttribute("data-type");
      }
    });
  document
    .querySelectorAll("iframe[data-type='lazy']")
    .forEach((el: Element) => {
      if (el instanceof HTMLElement) {
        el.setAttribute("src", el.getAttribute("data-src") as string);
      }
    });
};

export const loadScripts = () => {
  const timer: ReturnType<typeof setTimeout> = setTimeout(
    searchLazyScripts,
    300
  );
  const trigger = () => {
    searchLazyScripts();
    clearTimeout(timer);
  };
  const events: string[] = ["mouseover", "keydown", "touchmove", "touchstart"];
  events.forEach((e: string) =>
    window.addEventListener(e, trigger, { passive: true, once: true })
  );
};

export const addScript = (
  parentEl: string, // Add explicit type for parentEl parameter
  externalScript: string, // Add explicit type for externalScript parameter
  id: string, // Add explicit type for id parameter
  onLoadCallback: (() => void) | null = null, // Add explicit type for onLoadCallback parameter
  lazy: boolean = true
) => {
  if (!document.getElementById(`${id}`)) {
    onDocumentLoad(() => {
      // Use the imported onDocumentLoad function
      const el = document.getElementsByTagName(`${parentEl}`)[0];
      const script = document.createElement("script");
      script.id = id;
      script.type = "text/javascript";
      if (lazy) {
        script.dataset.src = `${externalScript}`;
        script.dataset.type = "lazy";
      } else {
        script.src = `${externalScript}`;
      }
      script.async = true;
      script.defer = true;
      if (onLoadCallback !== null) {
        script.onload = onLoadCallback;
      }
      el.appendChild(script);

      const link = document.createElement("link");
      link.rel = "preconnect";
      link.href = new URL(externalScript).origin;
      document.head.appendChild(link);

      loadScripts(); // Remove the undefined loadScripts function call
    });
  }
};

// FreshChat init
declare global {
  interface Window {
    fcWidget: any;
  }
}

export const initFreshChat = () => {
  if (typeof window.fcWidget !== "undefined") {
    onDocumentLoad(() => {
      setTimeout(() => {
        window.fcWidget.init({
          token: "3b17c5f7-513f-4cbd-9362-48cab37c5283",
          host: "https://wchat.freshchat.com",
        });
      }, 400);
    });
  }
};

export const scroll = (options: any = null, scrollTop: number = 120) => {
  const links = document.querySelectorAll("a");

  const scrollOptions =
    options === null
      ? {
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      }
      : options;

  links.forEach((link: Element) => {

    if (typeof (link as HTMLElement).dataset.blank !== "undefined") {
      if ((link as HTMLElement).dataset.blank === "true") {
        return;
      }
    }
    if ((link as HTMLAnchorElement).href.indexOf("#") > -1) {
      const observer = new MutationObserver((mutations) => {
        link.addEventListener("click", (e: Event) => {
          e.preventDefault();
          const eventTarget = e.target as HTMLElement;
          const closestLink = eventTarget?.closest('a');

          if (closestLink) {
            // Observer
            const el = `${(closestLink as HTMLAnchorElement).href.slice(
              (closestLink as HTMLAnchorElement).href.indexOf("#") + 1
            )}`;
            const target = document.getElementById(el);
            if (el === 'reserve-lane') {
              if (isMobile()) {
                scrollTop = -430;
              }
            }
            if (target) {
              e.preventDefault();
              observer.disconnect();
              setTimeout(() => {
                window.scrollTo({
                  left: 0,
                  top: target.offsetTop - scrollTop,
                  behavior: "smooth",
                });
              }, 100);
            } else {
              return true;
            }
          }
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
};

export const lazy = () => {
  const initInvisibleBackground = () => {
    const images = document.querySelectorAll<HTMLElement>(".lazy");
    const backgrounds =
      document.querySelectorAll<HTMLElement>(".lazy-background");
    const styles = document.querySelectorAll<HTMLElement>(".lazy-style");

    let currentScroll = document.scrollingElement?.scrollTop || document.documentElement.scrollTop || 0;

    if (typeof currentScroll !== "undefined" && currentScroll) {
      if (images.length > 0) {
        images.forEach((element) => {
          if (currentScroll + 350 > element.getBoundingClientRect().top - 350) {
            let imgSrc = element.dataset.src || "";
            if (
              canUseWebP() &&
              typeof element.dataset.webpSrc !== "undefined"
            ) {
              imgSrc = element.dataset.webpSrc || "";
            }
            (element as HTMLImageElement).src = imgSrc;
            element.classList.remove("lazy");
            delete element.dataset.src;
          }
        });
      }

      if (backgrounds.length > 0) {
        backgrounds.forEach((element) => {
          if (currentScroll + 250 > element.getBoundingClientRect().top - 250) {
            element.style.backgroundImage = `url('${element.dataset.background}')`;
            element.classList.remove("lazy-background");
            delete element.dataset.background;
          }
        });
      }
    }

    if (styles.length > 0) {
      styles.forEach((element: HTMLElement) => {
        // element.style = `${element.dataset.style}`;
        element.style.cssText = element.dataset.style || "";
        element.classList.remove("lazy-style");
        delete element.dataset.style;
      });
    }
  };

  initInvisibleBackground();
  window.addEventListener(
    "scroll",
    (e) => {
      initInvisibleBackground();
    },
    false
  );
};

export const lazyClasses = () => {
  const elements = document.querySelectorAll<HTMLElement>(".bat-lazy-class");
  if (elements.length > 0) {
    elements.forEach((element: HTMLElement) => {
      const bgClass = element.dataset.class || "";
      setTimeout(() => {
        if (bgClass !== '') element.classList.add(bgClass);
      }, 400);
    });
  }
};

export const onScroll = (position: number, callback: () => void) => {
  window.addEventListener("scroll", () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition >= position) {
      callback();
    }
  });
};

export const IsOfferPage = () => {
  // check if page has the offer class and in case yes then return true
  return document.body.classList.contains("page-template-page_offer");
};

export function convert24HourTo12Hour(timeString: string) {
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';

  let timeHour: number = parseInt(hours);

  if (parseInt(hours) >= 12) {
    period = 'PM';
    if (parseInt(hours) > 12) {
      timeHour -= 12;
    }
  }

  return `${timeHour} ${period}`;
}

export const isAdvancedBooking = (date: Date) => {
  const today = new Date();
  const sevenDaysLater = new Date(today);
  sevenDaysLater.setDate(today.getDate() + 7);
  return date >= sevenDaysLater;
};

export const resetBookingProcess = (options: {
  step: any,
  bookingStep: any,
  parentElement: any,
  offer: any,
  SqPayment: any,
  flashSale: any,
  selectedFlashSaleTimeslot: any,
  book: any,
  paymentControl: any,
  user: any
}) => {
  // options.parentElement.update(() => "");
  options.step.update(() => 1);
  options.bookingStep.update(() => 1);
  options.offer.update(() => false);
  options.SqPayment.update(() => null);
  options.flashSale.update(() => []);
  options.selectedFlashSaleTimeslot.update(() => null);

  options.book.update((obj: any) => {
    let o = { ...obj };
    o.date = null;
    o.dateString = null;
    o.timeslot = null;
    o.groupsize = null;
    o.shirt = null;
    o.medallion = null;
    o.location = null;
    o.user = {
      fullName: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      occasion: "",
      aproxGroupSize: "",
      notes: "",
    };
    o.policiesAccepted = 0;
    o.policiesToAccept = ["terms-and-conditions"];
    o.reference = null;
    o.knifeAddon = false;
    o.bigAxeAddon = false;
    o.bookingExtension = false;
    o.corkageAddon = false;
    o.hasAddons = false;
    o.lanes = 1;
    return o;
  });

  options.paymentControl.update((obj: any) => {
    let o = { ...obj };
    o.process = false;
    o.completed = false;
    o.informationCompleted = false;
    o.readyToSend = false;
    o.submit = false;
    return o;
  });

  options.user.update((obj: any) => {
    let o = { ...obj };
    o.email = "";
    o.firstName = "";
    o.lastName = "";
    o.company = "";
    o.phone = "";
    return o;
  });
};

export const convert24HoursFormat = (time: string): string => {
  const [hour, minute] = time.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const adjustedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
}

export const groupTimesByHour = (times: string[]) => {
  const grouped: Record<string, string[]> = {};

  for (const time of times) {
    // Extract the hour part (e.g., "13" from "13:15")
    const hour = time.substring(0, 2); // Gets "HH"
    // Create the base hour key (e.g., "13:00")
    const baseHour = `${hour}:00`;

    // If the base hour key doesn't exist in our grouped object, initialize it with an empty array
    if (!grouped[baseHour]) {
      grouped[baseHour] = [];
    }

    // Push the current time string into the array for its corresponding base hour
    grouped[baseHour].push(time);
  }

  return grouped;
}
